'use-strict';

const expandAll = (function() {
  const colorPortfolio = document.querySelector('.color-portfolio');
  const activeClass = 'js-expand-all-active';
  const openClass = 'is-open';
  let isMobile = false;
  let canShow = false;
  let contentArr = {};
  function breakpointHandler() {
    const viewportWidth =
      window.innerWidth || document.documentElement.clientWidth;
    return (isMobile = viewportWidth > 767 ? false : true);
  }
  function colorHomepageCheck() {
    if (window.location.href.split('/colors')[1].length <= 1) {
      canShow = true;
    } else {
      canShow = false;
    }
  }
  /**
   *
   * @param item - expand all element
   * @param id - expand all trigger id
   */
  function showLessHandler(item, id) {
    const trigger = item.querySelector('.js-expand-all-trigger');
    const content = item.querySelector('.js-expand-all-content');
    content.style.maxHeight = '';
    const contentMaxHeight = content.offsetHeight;
    const contentMinHeight = 130;
    contentArr[id] = {
      maxHeight: contentMaxHeight,
      minHeight: contentMinHeight,
    };
    hideHiddenContent(content, trigger);
  }
  /**
   *
   * @param el - expand all element
   * @param target - expand all trigger
   */
  function showHiddenContent(el, trigger) {
    const id = trigger.id;
    el.classList.add(activeClass);
    el.style.maxHeight = `${contentArr[id].maxHeight}px`;
    trigger.classList.add(openClass);
  }
  /**
   *
   * @param el - expand all element
   * @param target - expand all trigger
   */
  function hideHiddenContent(el, trigger) {
    const id = trigger.id;
    el.classList.remove(activeClass);
    el.style.maxHeight = `${contentArr[id].minHeight}px`;
    trigger.classList.remove(openClass);
  }
  /**
   *
   * @param e - click event
   */
  function toggle(e) {
    e.preventDefault();
    const triggerEl = e.currentTarget;
    const activeTrigger = document.querySelector(
      '.js-expand-all-trigger.is-open'
    );
    const expandedContent = document.querySelector(
      '.js-expand-all-content.js-expand-all-active'
    );
    const contentSelector = triggerEl.getAttribute('data-target');
    const contentEl = document.getElementById(contentSelector);
    if (triggerEl !== activeTrigger && expandedContent) {
      hideHiddenContent(expandedContent, activeTrigger);
    }
    if (!contentEl.classList.contains(activeClass)) {
      showHiddenContent(contentEl, triggerEl);
    } else {
      hideHiddenContent(contentEl, triggerEl);
    }
  }
  /**
   *
   * @param item - instance of expand all element
   * @param index - current index of forEach
   */
  function init(item, index) {
    const trigger = item.querySelector('.js-expand-all-trigger');
    const content = item.querySelector('.js-expand-all-content');
    content.style.maxHeight = '';
    trigger.id = `js-expand-all-trigger-${index}`;
    content.id = `js-expand-all-content-${index}`;
    trigger.setAttribute('data-target', content.id);
    content.setAttribute('data-show-all', index);
    showLessHandler(item, trigger.id);
    trigger.addEventListener('click', toggle);
  }
  window.addEventListener('DOMContentLoaded', () => {
    if (colorPortfolio) {
      breakpointHandler();
      colorHomepageCheck();
      // only initialize if mobile and on colors homepage
      if (isMobile && canShow) {
        const elements = document.querySelectorAll('.js-expand-all');
        [...elements].forEach((item, index) => {
          init(item, index);
        });
      }
    }
  });
})();

export default expandAll;
